import React from "react";
import styled from "styled-components";
import { formatCurrencyToNearestTen } from "../../formatting/formatCurrency";

export const ProjectCosts: React.FC<{
  pvHardwareLabel: string;
  pvHardwareCost: number;
  batteryHardwareLabel?: string;
  batteryCosts?: number;
  pvInstallationCost: number;
  enablingWorksCosts: number;
  additionalCosts?: number;
  currencyCode: string;
}> = ({
  pvHardwareLabel,
  pvHardwareCost,
  batteryHardwareLabel,
  batteryCosts,
  pvInstallationCost,
  enablingWorksCosts,
  additionalCosts,
  currencyCode,
}) => {
  return (
    <ProjectCostList>
      <ProjectCost
        label={pvHardwareLabel}
        value={formatCurrencyToNearestTen(
          pvHardwareCost,
          currencyCode,
          0,
          false
        )}
      />
      <ProjectCost
        label="Installation"
        value={formatCurrencyToNearestTen(
          pvInstallationCost,
          currencyCode,
          0,
          false
        )}
      />
      {batteryHardwareLabel && batteryCosts !== undefined && (
        <ProjectCost
          label={batteryHardwareLabel}
          value={formatCurrencyToNearestTen(
            batteryCosts,
            currencyCode,
            0,
            false
          )}
        />
      )}
      <ProjectCost
        label="Enabling Works"
        value={formatCurrencyToNearestTen(
          enablingWorksCosts,
          currencyCode,
          0,
          false
        )}
      />
      {additionalCosts !== undefined && (
        <ProjectCost
          label="Additional Costs"
          value={formatCurrencyToNearestTen(
            additionalCosts,
            currencyCode,
            0,
            false
          )}
        />
      )}
    </ProjectCostList>
  );
};

const ProjectCostList = styled.ul`
  margin: 0 8px;
  padding: 0;
  list-style: none;
`;

const ProjectCost: React.FC<{
  label: string;
  value: string;
}> = ({ label, value }) => {
  return (
    <ProjectCostListItem>
      <ProjectCostListItemLabel>{label}</ProjectCostListItemLabel>
      <ProjectCostListItemValue>{value}</ProjectCostListItemValue>
    </ProjectCostListItem>
  );
};

const ProjectCostListItem = styled.li`
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #f0f0f0;
  padding: 0 8px;
`;

const ProjectCostListItemLabel = styled.p``;

const ProjectCostListItemValue = styled.p`
  text-align: right;
`;
